import { PersonAttributes } from './estate-people'

export const NEW_PERSON = 'new'

/** Someone is only worth keeping as a contact once we know both names. */
export const hasBothNames = ({ firstNames, lastName }: PersonAttributes) =>
  !!(firstNames?.trim() && lastName?.trim())

export const fullName = ({ firstNames, lastName }: PersonAttributes) =>
  [firstNames, lastName].filter(Boolean).join(' ')

/** The collection hook shows a failed save's error, so it isn't left unhandled. */
export const ignoreFailure = (result: unknown) =>
  Promise.resolve(result).catch(() => undefined)
